import React from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const B = process.env.REACT_APP_BACKEND_URL;

export const C = {
  bg: "#F4F1ED", surface: "#FFFFFF", line: "#D1CCC3", ink: "#1C1A17",
  ink2: "#5C5852", muted: "#8A857D", terra: "#E05C3A", emerald: "#1A3626",
};
export const serif = { fontFamily: "'Playfair Display', 'Cormorant Garamond', serif" };
export const sans = { fontFamily: "'IBM Plex Sans', system-ui, sans-serif" };

export const NAV_LINKS = [
  ["Home", ""], ["Music", "c/music"], ["R&B", "c/r-b"], ["Soul", "c/soul"],
  ["Reggae", "c/reggae"], ["Interviews", "c/interviews"], ["Entertainment", "c/entertainment"],
  ["Radio", "c/radio"], ["Video", "c/videos"],
];

export const SubscribeBand = ({ slug }) => {
  const [email, setEmail] = React.useState("");
  const [state, setState] = React.useState("");
  const [err, setErr] = React.useState("");
  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setState("busy"); setErr("");
    try {
      await axios.post(`${B}/api/mag/public/${slug}/subscribe`, { email });
      setState("done");
    } catch (e2) {
      setState(""); setErr(e2?.response?.data?.detail || "Something went wrong — try again");
    }
  };
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-8 pb-16" data-testid="mag-subscribe-band">
      <div className="px-8 py-12 text-center" style={{ background: C.emerald }}>
        <div className="text-[11px] uppercase tracking-[0.25em] font-semibold mb-3" style={{ ...sans, color: "#F4B860" }}>The Newsletter</div>
        <h2 className="text-3xl sm:text-4xl font-black tracking-tight text-white" style={serif}>Get the week's best stories</h2>
        <p className="mt-2 text-sm text-white/70" style={sans}>One email a week. The features, interviews and new music that matter.</p>
        {state === "done" ? (
          <div className="mt-6 text-sm font-semibold" style={{ ...sans, color: "#F4B860" }} data-testid="mag-subscribe-success">
            You're on the list — see you in your inbox.
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 flex flex-col sm:flex-row justify-center gap-3 max-w-md mx-auto" style={sans}>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com" data-testid="mag-subscribe-email"
              className="flex-1 px-4 py-3 text-sm text-white placeholder-white/40 focus:outline-none"
              style={{ background: "rgba(255,255,255,0.08)", border: "1px solid rgba(255,255,255,0.2)" }} />
            <button type="submit" disabled={state === "busy"} data-testid="mag-subscribe-btn"
              className="px-6 py-3 text-xs uppercase tracking-[0.2em] font-bold text-white disabled:opacity-60" style={{ background: C.terra }}>
              {state === "busy" ? "Subscribing…" : "Subscribe"}
            </button>
          </form>
        )}
        {err && <div className="mt-3 text-xs" style={{ ...sans, color: "#F8A5A5" }} data-testid="mag-subscribe-error">{err}</div>}
      </div>
    </section>
  );
};

export const MagNav = ({ pub, slug }) => (
  <header className="sticky top-0 z-40 border-b" style={{ background: "rgba(244,241,237,0.85)", backdropFilter: "blur(16px)", borderColor: C.line }}>
    <div className="max-w-7xl mx-auto px-4 sm:px-8 py-4 flex flex-wrap items-center gap-x-8 gap-y-2">
      <Link to={`/mag/${slug}`} data-testid="mag-pub-logo" className="mr-auto">
        <div className="text-3xl font-black tracking-tighter" style={{ ...serif, color: C.ink }}>
          {(pub?.name || "ALL VIBIN'").replace(" Magazine", "").toUpperCase()}
        </div>
        <div className="text-[10px] uppercase tracking-[0.3em] font-semibold" style={{ ...sans, color: C.terra }}>
          {pub?.tagline || "Music • Culture • Entertainment"}
        </div>
      </Link>
      <nav className="flex flex-wrap gap-x-5 gap-y-1 text-xs uppercase tracking-[0.15em] font-semibold" style={sans}>
        {NAV_LINKS.map(([label, path]) => (
          <Link key={label} to={`/mag/${slug}${path ? `/${path}` : ""}`} data-testid={`mag-nav-${label.toLowerCase().replace("&", "")}`}
            className="transition-colors" style={{ color: C.ink2 }}
            onMouseEnter={(e) => (e.target.style.color = C.terra)} onMouseLeave={(e) => (e.target.style.color = C.ink2)}>
            {label}
          </Link>
        ))}
      </nav>
    </div>
  </header>
);

export const ArticleCard = ({ a, slug, big }) => (
  <Link to={`/mag/${slug}/a/${a.slug}`} data-testid={`mag-pub-card-${a.slug}`} className="group block">
    <div className="overflow-hidden" style={{ background: C.surface, border: `1px solid ${C.line}` }}>
      {a.featured_image ? (
        <div className={`overflow-hidden ${big ? "h-64" : "h-44"}`}>
          <img src={a.featured_image} alt={a.title} loading="lazy"
            className="w-full h-full object-cover transition-transform duration-500 ease-out group-hover:scale-105" />
        </div>
      ) : <div className={`${big ? "h-64" : "h-44"}`} style={{ background: C.emerald }} />}
      <div className="p-5">
        <div className="text-[10px] uppercase tracking-[0.2em] font-semibold mb-2" style={{ ...sans, color: C.terra }}>
          {(a.categories || [])[0] || "Feature"}
        </div>
        <h3 className={`${big ? "text-2xl" : "text-lg"} font-bold leading-snug transition-colors group-hover:text-[#E05C3A]`} style={{ ...serif, color: C.ink }}>
          {a.title}
        </h3>
        {a.subtitle && <p className="mt-2 text-sm leading-normal line-clamp-2" style={{ ...sans, color: C.ink2 }}>{a.subtitle}</p>}
        <div className="mt-3 text-[11px]" style={{ ...sans, color: C.muted }}>
          {a.author}{a.published_at ? ` · ${a.published_at.slice(0, 10)}` : ""} · {a.reading_time} min read
        </div>
      </div>
    </div>
  </Link>
);

export const SectionTitle = ({ children }) => (
  <div className="flex items-center gap-4 mb-6">
    <h2 className="text-3xl font-black tracking-tight" style={{ ...serif, color: "#1C1A17" }}>{children}</h2>
    <div className="flex-1 h-px" style={{ background: "#D1CCC3" }} />
  </div>
);
